import 'api/getip'
import 'logging/logging'

window.clog = console.log.bind(document);
window.clr  = {}